// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5efb2d9e].disabled.btn-outline-secondary:hover {\n  color: #984422 !important;\n}\n", ""]);
// Exports
module.exports = exports;
